/* ATW / FORM — επιλογή αρώματος
   - Native validation μηνύματα στα ελληνικά (required select μέσα στο product form).
   - Αν η πηγή έχει >50 προϊόντα, ολοκληρώνει τη λίστα από /collections/{handle}/products.json. */
(() => {
  if (window.__atwFormFragrance) return;
  window.__atwFormFragrance = true;

  const MSG = 'Επίλεξε άρωμα ή «Χωρίς άρωμα» για να συνεχίσεις.';
  const nameOf = (title) => String(title || '').split(' | ')[0].replace(/\s+/g, ' ').trim();

  async function hydrate(root, select) {
    const handle = root.dataset.source;
    const type = root.dataset.type || '';
    const warn = root.querySelector('[data-warning]');
    const names = new Set();
    try {
      for (let page = 1; page <= 20; page++) {
        const res = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        const items = data.products || [];
        items.forEach((p) => {
          if (type && p.product_type !== type) return;
          const n = nameOf(p.title);
          if (n) names.add(n);
        });
        if (items.length < 250) break;
      }
      const keep = select.value;
      const sorted = [...names].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base', numeric: true }));
      select.querySelectorAll('option[data-dynamic]').forEach((o) => o.remove());
      sorted.forEach((n) => {
        const o = document.createElement('option');
        o.value = n;
        o.textContent = n;
        o.dataset.dynamic = '';
        select.appendChild(o);
      });
      if (keep) select.value = keep;
    } catch (e) {
      if (warn) warn.hidden = false;
    }
  }

  function init(root) {
    if (root.dataset.atwReady) return;
    root.dataset.atwReady = '1';
    const select = root.querySelector('select');
    if (!select) return;
    const err = root.querySelector('[data-error]');
    const flag = (on) => {
      select.setAttribute('aria-invalid', on ? 'true' : 'false');
      if (err) err.hidden = !on;
    };
    select.addEventListener('invalid', () => { select.setCustomValidity(MSG); flag(true); });
    select.addEventListener('change', () => { select.setCustomValidity(''); flag(false); });
    if (root.dataset.more === 'true') hydrate(root, select);
  }

  const scan = () => document.querySelectorAll('[data-atw-form-fragrance]').forEach(init);
  scan();
  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
